<template>
  <v-chip
    data-testid="vcita-chip-id"
    tabindex="0"
    :close="includeCloseButton"
    outlined
    close-icon="close"
    class="vcita-chip ps-0 pe-3"
    :disabled="disabled"
    @click="onClick"
    @click:close="onClickClose">
    <div class="d-flex align-center overflow-hidden">
      <AvatarImage v-if="avatar && items" class="d-none d-md-flex avatar me-n1"
                   :image-path="avatar.path"
                   :name="avatar.name"
                   custom-size="24px"/>
      <div class="d-none d-md-flex font-weight-medium desktop-typography-div ms-3">
        <span class="group-name-span font-weight-regular" v-if="groupName">{{groupName}}</span>
        <span class="me-2 ms-2 pipeline-span" v-if="groupName">|</span>
        <v-tooltip top max-width="224px" v-if="shouldPresentRestItems">
          <template v-slot:activator="{ on }">
              <span v-on="on">
                {{itemsForChip}}
                <span class="rest-group-items-span ms-1" v-if="shouldPresentRestItems">{{numberOfRestItems}}</span>
              </span>
            </template>
            {{itemsForHoverTooltip}}
          </v-tooltip>
          <span v-if="!shouldPresentRestItems">{{itemsForChip}}</span>
      </div>
      <span class="d-md-none mx-2">
        {{itemsForChip}}
      </span>
    </div>
  </v-chip>
</template>

<script>
import {AvatarImage} from "@/modules/common/components";
export default {
  name: "VcitaChip",
  methods:{
    onClick(e){
      this.$emit('click', e)
    },
    onClickClose(){
      this.$emit('click:close')
    }
  },
  components: {AvatarImage},
  props:{
    items: {
      type: Array,
      required: true
    },
    groupName: {
      type: String,
      required: false
    },
    avatar: {
      type: Object,
      required:false
    },
    disabled:{
      type: Boolean,
      default: false
    },
    includeCloseButton:{
      type: Boolean,
      default: true
    }
  },
  computed:{
    itemsForChip(){
      let itemsLength = this.items.length
      if(itemsLength >= 2)
        return `${this.items[0]}, ${this.items[1]}`
      else if(itemsLength > 0)
        return this.items[0]
    },
    itemsForHoverTooltip(){
      return this.items.join(", ")
    },
    numberOfRestItems(){
      let itemsLength = this.items.length
      return `(+${itemsLength - 2})`
    },
    shouldPresentRestItems(){
      return this.items.length > 2
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_mixins.scss";
@import '@/assets/scss/abstract/_i18n-mixins';
@import "@/assets/scss/abstract/_variables.scss";
  .vcita-chip{
    user-select: none;
    transition: background-color .1s ease;
    max-height: 24px;
    line-height: 24px;

    &::v-deep{
      &.v-chip.v-chip--outlined.v-chip.v-chip{
        &:hover{
          background-color: rgba(0, 0, 0, 0.07)!important;
        }
        &:active:focus{
          box-shadow: none;
        }
        &:focus-visible{
          box-shadow: 0px 0px 0px 3px rgba(var(--brand-color-secondary-rgb), 0.36);
        }
        &:active{
          background-color: rgba(0, 0, 0, 0.2) !important;
        }

        &.v-chip--disabled{
          opacity: 1;
          background-color: rgba(0, 0, 0, 0.07) !important;
          color: $color_semi_dark_icon;

          span.group-name-span{
            color: $color_semi_dark_icon;
          }
        }
      }
      &.v-chip.v-chip--outlined .v-icon {
        color: rgba(0, 0, 0, 0.4);
      }
      &.theme--light.v-chip {
        border: 1px solid $gray_color-16;
      }
      &.v-chip.v-size--default{
        font-size: 13px;
        @include sm-and-down{
          font-size: 12px;
        }
      }
    }
  }
  .avatar{
    margin-left: -1px;
  }
  .group-name-span{
    color:rgba(0, 0, 0, 0.62);
  }
  .pipeline-span{
    color: $grey-color-7;
  }
  .group-items-span{
    color: $black-color-2;
  }
  .rest-group-items-span{
    font-weight: 600;
  }
  .desktop-typography-div{
    font-weight: 500;
    font-family: var(--primary-font-family);
    font-style: normal;
    max-height: 14px;
    line-height: 14px;
  }
  .v-tooltip__content{
    background: rgba(0, 0, 0, 0.87);
    border-radius: 4px;
    font-family: var(--primary-font-family);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
  }

</style>
